export default __webpack_public_path__ + "static/media/csvUpload.aa63b02b.svg";